export function inflateAudioParams(node, componentProps, otherComponents) {
  // Do nothing, audio-params are handled in the audio inflator.
}
